import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TimeSeriesLayer } from '~/packages/general/variable/variables.typing'
import { ButtonLink, ButtonLinkAsSimpleText } from '~/prix/react/components/button'
import Editor from '@monaco-editor/react'
import { toastError } from '~/components/toasts'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  border-radius: ${props => props.theme.borderRadius};
  border: 1px solid ${props => props.theme.colors.mediumGrey};

  .editor {
    display: flex;
    height: 420px;
    padding: 5px 0;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
  }
`

interface LayerAnalysis {
  timeSeries?: {
    model?: 'additive' | 'multiplicative'
    fitDays?: number
    layers?: TimeSeriesLayer[]
  }
}

interface TimeAnalysisReportDeveloperToolsProps {
  layerAnalysis: LayerAnalysis
  onChangeLayerAnalysis: (layerAnalysis: LayerAnalysis) => void
}

export default function TimeAnalysisReportDeveloperTools({
  layerAnalysis,
  onChangeLayerAnalysis,
}: TimeAnalysisReportDeveloperToolsProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [layerAnalysisString, setLayerAnalysisString] = useState<string | null>(null)

  useEffect(() => {
    setLayerAnalysisString(JSON.stringify(layerAnalysis, null, 2))
  }, [layerAnalysis])

  const handleSave = () => {
    if (layerAnalysisString) {
      try {
        const newLayerAnalysis = JSON.parse(layerAnalysisString)
        onChangeLayerAnalysis(newLayerAnalysis)
      } catch (error) {
        toastError((error as Error).message)
        console.error(error)
      }
    }
  }

  if (!isOpen) {
    return (
      <React.Fragment>
        Para desenvolvedores:{' '}
        <ButtonLink styleType='lightGrey' onGo={() => setIsOpen(true)}>
          Editar
        </ButtonLink>
      </React.Fragment>
    )
  }

  const monacoOptions = {
    insertSpaces: true,
    tabSize: 2,
    detectIndentation: false,
    minimap: {
      enabled: false,
    },
  }

  return (
    <Wrapper>
      {layerAnalysisString ? (
        <div className='editor'>
          <Editor
            defaultLanguage='json'
            options={monacoOptions}
            value={layerAnalysisString}
            onChange={newLayerAnalysisString =>
              setLayerAnalysisString(newLayerAnalysisString ?? '')
            }
          />
        </div>
      ) : null}
      <div className='buttons'>
        <ButtonLinkAsSimpleText onGo={() => setIsOpen(false)}>Cancelar</ButtonLinkAsSimpleText>
        <ButtonLink onGo={handleSave}>Testar</ButtonLink>
      </div>
    </Wrapper>
  )
}
